import React from 'react';
import { Star } from 'lucide-react';

function StarRating({ 
  rating = 0, 
  maxStars = 5, 
  size = 14, 
  interactive = false, 
  onChange = null 
}) {
  const [hoverRating, setHoverRating] = React.useState(0);

  const displayRating = interactive ? (hoverRating || rating) : rating;

  const handleClick = (value) => {
    if (interactive && onChange) {
      onChange(value);
    }
  };

  const handleMouseEnter = (value) => {
    if (interactive) {
      setHoverRating(value);
    }
  };

  const handleMouseLeave = () => {
    if (interactive) {
      setHoverRating(0);
    }
  };

  return (
    <span className="flex items-center gap-0.5">
      {[...Array(maxStars)].map((_, i) => (
        <Star
          key={i}
          size={size}
          className={`
            ${i < displayRating 
              ? 'text-primary fill-primary' 
              : 'text-primary/30'
            }
            ${interactive ? 'cursor-pointer transition-all hover:scale-110' : ''}
          `}
          onClick={() => interactive && handleClick(i + 1)}
          onMouseEnter={() => interactive && handleMouseEnter(i + 1)}
          onMouseLeave={handleMouseLeave}
        />
      ))}
      {/* {rating > 0 && (
        <span className="text-xs text-warning ml-1 font-medium">
          {rating}.0
        </span>
      )} */}
    </span>
  );
}

export default StarRating;
